import Vue from 'vue'

// export const exmple = (state, payload) => {
    
// }

export const setRanking = (state, payload) => {
    Vue.set(state, 'ranking', payload)
}
